export const QUERY_REPORT_VIEW = `query ViewReport($charge: String!, $articleNumber:String!){ 
	viewReport(charge:$charge, articleNumber: $articleNumber) {
    id
    name
    report_number
    customer
    customer_order_number
    shipping_date
    order_confirmation
    secret
    sheets {
        id
    }
  }
}`;
